<form action="#" method="post" class="ex-calc" autocomplete="off">
    <div class="form-group" *ngIf="sendCurrency">
        <label for="send" class="text-orange text-bold mb-0">Send</label>
        <div class="input-group">
            <input type="text" class="form-control" name="amountInpt" (ngModelChange)="sendAmountChange($event)"
                [(ngModel)]="exchange.amount" aria-label="Text input with dropdown button">
            <div class="input-group-append dropleft" id="sendDropdown">
                <button  class="btn btn-outline-secondary" type="button" nz-popover nzPopoverTrigger="click"
                    nzPopoverPlacement="bottomRight" [nzPopoverContent]="sendCurrencyPopover"
                    [(nzPopoverVisible)]="exCalcSendPopoverVisible"
                    (nzPopoverVisibleChange)="changeSendPopoverVisiblity($event)">
                    <img src="https://singxco.github.io/static-data/images/flags/4x3/{{sendCurrency.flag}}.svg" alt="">
                    {{sendCurrency.currencyCode}}&nbsp;&nbsp;<i class="fa-solid fa-caret-down"></i>
                </button>
                <ng-template #sendCurrencyPopover>
                    <div class="card ex-calc-popover-card">
                        <div class="card-body">
                            <span class="dropdown-header"><input class="form-control cFilterInpt" type="text"
                                    name="sendFilterInpt" id="sendFilterInpt" autocomplete="off" placeholder="Search"
                                    [(ngModel)]="sendFilterInpt"></span>
                            <div id="sendItems">
                                <a rel="noreferrer" class="dropdown-item"
                                    *ngFor="let sc of sendCurrencies | currencyFilter:sendFilterInpt"
                                    (click)="changeSendCurrency(sc);"><img
                                        src="https://singxco.github.io/static-data/images/flags/4x3/{{sc.flag}}.svg"
                                        alt="{{sc.currencyCode}}">{{sc.currencyCode}} -
                                    {{sc.currencyName}}
                                </a>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="form-group" *ngIf="receiveCurrency">
        <label for="receive" class="text-orange text-bold mb-0">Receive</label>
        <div class="input-group">
            <input type="text" class="form-control" name="receiveAmountInpt"
                (ngModelChange)="receiveAmountChange($event)" [(ngModel)]="exchange.receiveAmt"
                aria-label="Text input with dropdown button">
            <div class="input-group-append" id="receiveDropdown">
                <button  class="btn btn-outline-secondary" type="button" nz-popover nzPopoverTrigger="click"
                    nzPopoverPlacement="bottomRight" [nzPopoverContent]="receiveCurrencyPopover"
                    [(nzPopoverVisible)]="exCalcReceivePopoverVisible"
                    (nzPopoverVisibleChange)="changeReceivePopoverVisiblity($event)">
                    <img src="https://singxco.github.io/static-data/images/flags/4x3/{{receiveCurrency.flag}}.svg"
                        alt="">
                    {{receiveCurrency.currencyCode}}&nbsp;&nbsp;<i class="fa-solid fa-caret-down"></i>
                </button>
                <ng-template #receiveCurrencyPopover>
                    <div class="card ex-calc-popover-card">
                        <div class="card-body">
                            <span class="dropdown-header"><input class="form-control cFilterInpt" type="text"
                                    name="receiveFilterInpt" id="receiveFilterInpt" autocomplete="off"
                                    placeholder="Search" [(ngModel)]="receiveFilterInpt"></span>
                            <div id="receiveItems">
                                <a rel="noreferrer" class="dropdown-item"
                                    *ngFor="let sc of countryList | currencyFilter:receiveFilterInpt"
                                    (click)="changeReceiveCurrency(sc);"><img
                                        src="https://singxco.github.io/static-data/images/flags/4x3/{{sc.flag}}.svg"
                                        alt="{{sc.currencyCode}}">{{sc.currencyCode}} -
                                    {{sc.currencyName}}
                                </a>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <p class="mt-2 mb-1">Fee: {{exchange.singxFee | number: '1.2-4'}}
        {{exchange.fromId}}</p>
    <p *ngIf="!showInverseRates">
        <span>Exchange rate: </span> <span>1 {{exchange.fromId}}
            <span (click)="showInverseRates = !showInverseRates" class="exchange-toggler mx-2"><i
                    class="fa-solid fa-right-left text-orange"></i></span>
            {{exchange.exchangeRate | number: '1.2-4'}}
            {{exchange.toId}}</span>
        <i nz-tooltip
            nzTooltipTitle="This is the real mid-market exchange rate at which banks transact with each other. The retail rates you get with other providers will be significantly higher."
            class="ml-1 fa-regular fa-circle-question"></i>
    </p>
    <p *ngIf=" showInverseRates">
        <span>Exchange rate: </span> <span>1 {{exchange.toId}}
            <span (click)="showInverseRates = !showInverseRates" class="exchange-toggler mx-2"><i
                    class="fa-solid fa-right-left text-orange"></i></span>
            {{ 1 / exchange.exchangeRate | number: '1.2-4'}}
            {{exchange.fromId}}</span><i nz-tooltip
            nzTooltipTitle="This is the real mid-market exchange rate at which banks transact with each other. The retail rates you get with other providers will be significantly higher."
            class="ml-1 fa-regular fa-circle-question"></i>
    </p>
</form>